var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFilter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7474 10.5731C6.7474 10.8952 7.00856 11.1564 7.33073 11.1564L8.4974 11.1564C8.81956 11.1564 9.08073 10.8952 9.08073 10.5731C9.08073 10.2509 8.81956 9.98975 8.4974 9.98975L7.33073 9.98975C7.00856 9.98975 6.7474 10.2509 6.7474 10.5731ZM4.41406 7.07308C4.41406 7.39525 4.67523 7.65641 4.9974 7.65641L10.8307 7.65641C11.1529 7.65641 11.4141 7.39524 11.4141 7.07308C11.4141 6.75091 11.1529 6.48974 10.8307 6.48974L4.9974 6.48975C4.67523 6.48975 4.41406 6.75091 4.41406 7.07308ZM3.2474 2.98975C2.92523 2.98975 2.66406 3.25091 2.66406 3.57308C2.66406 3.89525 2.92523 4.15641 3.2474 4.15641L12.5807 4.15641C12.9029 4.15641 13.1641 3.89524 13.1641 3.57308C13.1641 3.25091 12.9029 2.98974 12.5807 2.98974L3.2474 2.98975Z",
    fill: "#7F859D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-filter.335b500d.svg";
export { ForwardRef as ReactComponent };